<section class="section wf-section">
  <div class="div-block">
    <div class="kachel">
      <h1 class="heading-3 text-center mb-4">Anmelden</h1>
      <div class="form-block w-form">
        <form [formGroup]="form" class="pt-2">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Benutzername</mat-label>
            <input type="text" matInput formControlName="username">
          </mat-form-field>

          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Passwort</mat-label>
            <input type="password" matInput formControlName="password">
          </mat-form-field>
          <div class="alert alert-warning" *ngIf="failedLogin">Zugangsdaten sind nicht korrekt, bitte erneut
            versuchen.</div>

          <div class="mt-2">
            <mat-spinner [diameter]="20" style="margin: 12px" *ngIf="isLoading"> </mat-spinner>

            <button (click)="onSubmit()" class="button" *ngIf="!isLoading"
              style="width: 100%;">Anmelden</button>
          </div>

          <div class="mt-5 text-center">
            <a routerLink="/register">Registrieren</a>
          </div>

          <br>
          <div class="text-center">
            <a routerLink="/forgot-password">Passwort vergessen?</a>
          </div>
          <br>


          <div class="mt-5 text-center">
            <a routerLink="/inquiry">Anfrage starten</a>
          </div>


          <hr style="color: grey;margin: 20px;">
          <div style="display: flex; justify-content: center;">
            <small style="color: gray;">v{{versions.hash}} - {{versions.date | date: "yyyy-MM-dd HH:mm"}}</small>
          </div>

        </form>
      </div>
    </div>
  </div>
</section>
